import Apis from '@/Apis/_'
import { FornecedorOPME } from '@/types/_'

class BackofficeSharedDataService {
  solicitacaoAlterada: any

  // Options
  fornecedorOptions: FornecedorOPME[]
  materialOptions: MaterialOptions[]

  async loadMaterialOptions() {
    const { hospitalId, medicoSolicitanteId, solicitacaoId } = this.solicitacaoAlterada
    const res = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMedicoOpme(hospitalId, medicoSolicitanteId, solicitacaoId)

    if (res.success) {
      this.materialOptions = res.data.opmes
    }
  }

  async loadFornecedorOptions() {
    const { hospitalId, medicoSolicitanteId, solicitacaoId } = this.solicitacaoAlterada
    const convenioId = this.solicitacaoAlterada.paciente.convenioId || 'e8496173-7c9d-43b2-9f01-4d490d69042b'
    const res = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllFornecedor(hospitalId, convenioId, medicoSolicitanteId, solicitacaoId)

    if (res.success) {
      this.fornecedorOptions = res.data
    }
  }

  reset() {
    this.solicitacaoAlterada = {}
    this.fornecedorOptions = []
    this.materialOptions = []
  }
}

interface MaterialOptions {
  id: string,
  descricao: string,
  possuiGrade: boolean,
  disabled: boolean,
}

// eslint-disable-next-line import/prefer-default-export
export const backofficeSharedDataService = new BackofficeSharedDataService()
